import { createContext, useContext } from 'react'

import type { Poll, RenderPollUnitWrapper } from '../model/Poll'

export type PollsContextValue = {
  renderPollUnitWrapper?: RenderPollUnitWrapper
  isVotingAllowed: boolean
  canChangePoll: boolean
  disableOverlayTrigger: boolean
  activatePoll: (poll: Poll) => void
  answerPoll: (poll: Poll, optionId: number, uuid?: string) => void
}

const PollsContext = createContext<PollsContextValue | null>(null)

export const PollsProvider = PollsContext.Provider

export const usePollsContext = (): PollsContextValue => {
  const context = useContext(PollsContext)

  if (context === null) {
    throw new Error('usePollsContext must be used within <Polls />')
  }

  return context
}
